import { createEntityAdapter, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../rootReducer'

export interface IInternetState {
  badInternet: boolean
}

export const initialInternetState: IInternetState = {
  badInternet: false,
}

const internetAdapter = createEntityAdapter()

export const internetSlice = createSlice({
  name: 'internet',
  initialState: internetAdapter.getInitialState(initialInternetState),
  reducers: {
    setBadInternet: (state, action: PayloadAction<boolean>) => {
      state.badInternet = action.payload
    },
  },
})

export const { setBadInternet } = internetSlice.actions

export const { selectAll: internetSelector } = internetAdapter.getSelectors(
  (state: RootState) => state[internetSlice.name],
)

export const selectInternetState = (state: RootState) => state.internet
